import DOMPurify from "dompurify";

/**
 * HTML sanitizer (Faz 9).
 *
 * Kullanıcı/backend kaynaklı HTML'i React'e basmadan önce buradan geçirmek
 * zorunludur. `dangerouslySetInnerHTML={ __html: html }` yerine
 * `dangerouslySetInnerHTML={{ __html: sanitize(html) }}` yazın.
 *
 * Varsayılan profil zengin metin (rich-text) içeriği için: img/blockquote/
 * code/list/heading/link gibi etiketler güvenli; `script`, `style`,
 * `iframe`, event handler'ları otomatik strip'lenir.
 *
 * Düz metin için `sanitizeText(html)` kullanın (tüm tag'ları çıkarır).
 */

const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: [
    "a", "b", "i", "em", "strong", "u", "s", "sub", "sup",
    "p", "br", "div", "span",
    "ul", "ol", "li",
    "blockquote", "pre", "code",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "img", "figure", "figcaption",
    "table", "thead", "tbody", "tr", "th", "td",
    "hr",
  ],
  ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "rel", "class", "style"],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data:image\/[\w-]+;base64,):|\/|#)/i,
  ADD_ATTR: ["target"],
};

export const sanitize = (html) => {
  if (html == null || html === "") return "";
  return DOMPurify.sanitize(String(html), RICH_TEXT_CONFIG);
};

export const sanitizeText = (html) => {
  if (html == null || html === "") return "";
  return DOMPurify.sanitize(String(html), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};

export default sanitize;
